import React from 'react'

const LoadingPage = () => (
  <div className="loader">
    <img 
      className="loader__image"    src="https://storage.googleapis.com/russellmschmidt-net-portfolio/loaders/loading-anim-1.gif" 
      alt="page loading gif"
    />
  </div>
)

export default LoadingPage


// WEBPACK FOOTER //
// ./src/components/LoadingPage.js